import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ElektronikPremiumCalculationService } from '@base/app/features/calculator-overview/services/elektronik-premium-calculation.service';
import { createElektronikCalculatorForm, ElektronikCalculatorFormModel } from '../../factories/tech-calculator-form.factory';
import { ElektronikService } from '../../services/elektronik.service';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs';

@Component({
  selector: 'app-elektronik-calculator',
  standalone: true,
  imports: [
    CurrencyPipe,
    PaginatorModule,
    ReactiveFormsModule
  ],
  templateUrl: './elektronik-calculator.component.html',
  styleUrl: './elektronik-calculator.component.scss',
  providers: [ElektronikPremiumCalculationService]
})
export class ElektronikCalculatorComponent implements OnInit {
  private readonly elektronikService = inject(ElektronikService);

  @Output() requestOffer = new EventEmitter<{ initialPrice: number, premium: number }>();

  form!: FormGroup<ElektronikCalculatorFormModel>;
  premium: number | null = null;

  ngOnInit() {
    this.form = createElektronikCalculatorForm();

    this.form.valueChanges.pipe(
      debounceTime(300),
      filter(value => value.initialPrice !== null && value.initialPrice !== undefined),
      distinctUntilChanged((prev, curr) => prev.initialPrice === curr.initialPrice),
      switchMap(value => this.elektronikService.getPremium(value.initialPrice!))
    )
      .subscribe(premium => {
        this.premium = premium;
      });
  }

  submit(): void {
    this.form.markAllAsTouched();

    if (this.form.invalid || this.premium === null) {
      return;
    }

    this.requestOffer.emit({
      initialPrice: this.form.getRawValue().initialPrice!,
      premium: this.premium
    });
  }
}
